import { SECTION_TYPES } from './constants'

const formMarkup = [
  {
    type: SECTION_TYPES.SECTION,
    content: [
      {
        type: SECTION_TYPES.BODY,
        content: `Please fill out the form and submit your request.`
      },
      {
        type: SECTION_TYPES.BODY,
        content: ``
      },
      {
        type: SECTION_TYPES.BODY,
        content: `IMPORTANT: If you are submitting this request on behalf of someone else, please call [1-866-984-7207](tel:+1-866-984-7207) before submitting this form as we will need to verify that you are an authorized agent.`
      },
      {
        type: SECTION_TYPES.BODY,
        content: `If you are requesting to access or delete your personal information, we are required to verify your identity to begin processing your request. The information you provide in this form may be shared with a third-party tool to verify your identity. By submitting this form, you acknowledge and accept this.`
      },
      {
        type: SECTION_TYPES.BODY,
        content: `Please note that submission of this form only exercises your rights with the Southern California Toyota Dealers Advertising Association.`
      }
    ]
  },
  {
    type: SECTION_TYPES.SECTION,
    content: [
      {
        type: SECTION_TYPES.HEADER,
        content: `Please be advised that using this form does not also exercise your rights with Toyota Motor Sales, U.S.A., Inc., Toyota Motor North America, Inc. and their wholly-owned subsidiaries that share common branding with them, together with Toyota Motor Corporation (“Toyota”), any Toyota dealers, private distributors, Toyota Financial Services, or Toyota Insurance Management Solutions.`
      },
      {
        type: SECTION_TYPES.BODY,
        content: ``
      }
    ]
  },
  {
    type: SECTION_TYPES.SECTION,
    content: [
      {
        type: SECTION_TYPES.HEADER,
        content: `If you wish to exercise your rights with the above entities, you will need to do so by contacting them directly. To exercise your rights with Toyota, please visit https://privacy.toyota.com/.`
      },
      {
        type: SECTION_TYPES.BODY,
        content: ``
      }
    ]
  },
  {
    type: SECTION_TYPES.SECTION,
    content: [
      {
        type: SECTION_TYPES.HEADER,
        content: `Please visit our [Privacy Statement](https://www.buyatoyota.com/socal/legal/) and for California residents, our [California Privacy Policy](https://www.buyatoyota.com/socal/california-privacy/) for additional information. `
      },
      {
        type: SECTION_TYPES.BODY,
        content: ``
      }
    ]
  },
  {
    type: SECTION_TYPES.SECTION,
    content: [
      {
        type: SECTION_TYPES.BODY,
        content: `By providing your mobile number you consent to us contacting you for verification purposes. Message and data rates may apply.`
      },
      {
        type: SECTION_TYPES.BODY,
        content: `If you are unable to provide the required information, please contact us at [1-866-984-7207](tel:+1-866-984-7207).`
      },
    ]
  }
];

export default formMarkup